import { connect } from 'react-redux';
import { requestHotel } from '../modules/hotels';

import BrowseHotelDetail from '../components/BrowseHotelDetail';

const mapDispatchToProps = {
  requestHotel,
};

const mapStateToProps = (state, ownProps) => ({
  isFetching: state.hotels.selectedHotel.isFetching,
  needFetch: state.hotels.selectedHotel.needFetch,
  hasError: state.hotels.selectedHotel.hasError,
  hotel: state.hotels.selectedHotel.hotel,
  perms: state.auth.perms,
  id: ownProps.params.id,
  action: ownProps.params.action ? ownProps.params.action : 'view',
});

export default connect(mapStateToProps, mapDispatchToProps)(BrowseHotelDetail);



// WEBPACK FOOTER //
// src/routes/hotels/containers/BrowseHotelDetailContainer.js